/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, April 2020
 */

import React from 'react';
import { FlowBlockParagraph as ParagraphBlockModel } from '@staffino/model';
import { Paragraph } from '@staffino/primitive-controls';
import ReactMarkdown from 'react-markdown';

type CustomImageProps = React.ImgHTMLAttributes<HTMLImageElement>;
function CustomImage({ src, alt, title, ...rest }: CustomImageProps) {
  return (
    <img
      src={src}
      alt={alt}
      title={title}
      {...rest}
      style={{ maxWidth: '100%' }}
    />
  );
}

type Props = {
  block: ParagraphBlockModel;
};

function ParagraphBlock({ block }: Props) {
  return (
    <Paragraph
      textAlign="center"
      color={block.color}
      fontSize={block.fontSize}
      maxWidth="100%"
    >
      <ReactMarkdown linkTarget="blank" components={{ img: CustomImage }}>
        {block.text?.replace(/\n/gi, '\n &nbsp;')}
      </ReactMarkdown>
    </Paragraph>
  );
}

export default ParagraphBlock;
